export const skills = {
  en: {
    title: 'Skills',
    ai: {
      title: 'AI & Machine Learning',
      description: 'LLMs (GPT, Ollama, Gemini), Generative AI, CNNs, YOLO'
    },
    frameworks: {
      title: 'Frameworks',
      description: 'LangChain, TensorFlow, Keras, PyTorch, Scikit-learn, Pandas'
    },
    development: {
      title: 'Development',
      description: 'Python, Java, JavaScript, ReactJS, AngularJS'
    },
    infrastructure: {
      title: 'Infrastructure',
      description: 'AWS (EC2, RDS, S3), Docker, Git'
    },
    databases: {
      title: 'Databases',
      description: 'PostgreSQL, MySQL'
    }
  },
  pt: {
    title: 'Habilidades',
    ai: {
      title: 'IA & Machine Learning',
      description: 'LLMs (GPT, Ollama, Gemini), IA Generativa, CNNs, YOLO'
    },
    frameworks: {
      title: 'Frameworks',
      description: 'LangChain, TensorFlow, Keras, PyTorch, Scikit-learn, Pandas'
    },
    development: {
      title: 'Desenvolvimento',
      description: 'Python, Java, JavaScript, ReactJS, AngularJS'
    },
    infrastructure: {
      title: 'Infraestrutura',
      description: 'AWS (EC2, RDS, S3), Docker, Git'
    },
    databases: {
      title: 'Bancos de Dados',
      description: 'PostgreSQL, MySQL'
    }
  }
};